<script setup lang="ts">
import Section          from "@ViewCommonComponents/Section.vue";
import Container        from "@ViewCommonComponents/Container.vue";
import SectionTitleTwo  from "@ViewCommonComponents/SectionTitleTwo.vue";
import ConsultationForm from "@ViewPages/Main/Components/Common/ConsultationForm.vue";

const formClasses = [
    'consultation__form',
    'flex max-md:flex-col md:justify-between md:flex-wrap xl:flex-nowrap',
    'max-md:gap-y-3.5 md:gap-x-6 md:gap-y-4',
].join(' ');
</script>

<template>
    <Section classes="consultation" id="consultation">
        <Container>
            <div class="consultation__inner">
                <SectionTitleTwo classes="mb-5"
                                 v-html="__('consultation_title')"></SectionTitleTwo>

                <div class="consultation__descr max-w-4xl text-center mx-auto mb-45px xl:mb-65px">
                    {{ __('consultation_description') }}
                </div>

                <ConsultationForm :form-classes="formClasses"></ConsultationForm>
            </div>
        </Container>
    </Section>
</template>

<style scoped>

</style>
